import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Saudi Arabian National ID validator following Single Responsibility Principle
 */
export class SaValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Saudi Arabian National ID',
      pattern: /^[12]\d{9}$/,
      length: 10
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Saudi ID must start with 1 or 2 followed by 9 digits'
    );
  }

  validateChecksum(id) {
    // Saudi ID uses Luhn algorithm
    let sum = 0;
    let alternate = false;

    for (let i = id.length - 2; i >= 0; i--) {
      let n = parseInt(id[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(id[id.length - 1]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Saudi ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Saudi Arabian National ID');
  }
}